const actions = {
  SET_ACCOUNT: 'SET_ACCOUNT',
  setAccount: data => ({
    type: actions.SET_ACCOUNT,
    payload: data
  })
}
export default actions
